import { Icon } from './icons';

export type AutosaveState = 'idle' | 'saving' | 'saved' | 'error';

export function AutosaveIndicator({
  state,
  onRetry,
}: {
  state: AutosaveState;
  onRetry?: () => void;
}) {
  if (state === 'saving') {
    return (
      <span className="ts-save ts-save--saving" aria-live="polite">
        <span className="ts-save-dot" /> Saving…
      </span>
    );
  }
  if (state === 'error') {
    return (
      <span className="ts-save ts-save--error" aria-live="assertive">
        <Icon name="alert" size={12} /> Couldn’t save
        {onRetry && (
          <button type="button" className="ts-save-retry" onClick={onRetry}>
            Retry
          </button>
        )}
      </span>
    );
  }
  if (state === 'saved') {
    return (
      <span className="ts-save" aria-live="polite">
        <Icon name="check" size={12} /> Saved
      </span>
    );
  }
  return null;
}
